import config from "../config"

function setPurchases(purchases) {
  window.localStorage.setItem(config.localStorageKeys.purchases, JSON.stringify(purchases))
}

function getPurchases() {
  let purchases = []
  let s = window.localStorage.getItem(config.localStorageKeys.purchases)
  if(s) {
    try {
      purchases = JSON.parse(s)
    }
    catch(error) {
      purchases = []
    }
  }
  return purchases
}

/**
 * Reads the adventure (i.e. the cart content) from localStorage.
 * Note: all this does is to read the string from local storage and attempt to convert it into a POJO.
 */
function getAdventure() {
  let adventure = null
  let s = window.localStorage.getItem(config.localStorageKeys.adventure)
  if(s) {
    try {
      adventure = JSON.parse(s)
    }
    catch(error) {
      adventure = null
    }
  }
  return adventure
}

/**
 * Stores adventure in local storage
 * @param {*} adventure 
 */
function setAdventure(adventure) {
  window.localStorage.setItem(config.localStorageKeys.adventure, JSON.stringify(adventure));
}

function getFavourites() {
  let favourites = []
  let s = window.localStorage.getItem(config.localStorageKeys.favourites)
  if(s) {
    try {
      favourites = JSON.parse(s)
    }
    catch(error) {
      console.error(error)
      favourites = []
    }
  }
  return favourites
}

function setFavourites(favourites) {
  window.localStorage.setItem(config.localStorageKeys.favourites, JSON.stringify(favourites))
}

function getCheckoutProgress() {
  let s = window.localStorage.getItem(config.localStorageKeys.checkoutProgress)
  let index = parseInt(s)
  return isNaN(index) ? 0 : index
}

function setCheckoutProgress(stepIndex) {
  let current = getCheckoutProgress()
  if(stepIndex > current) {
    // we only move forward
    window.localStorage.setItem(config.localStorageKeys.checkoutProgress, stepIndex)
  }
}

function resetCheckoutProgress() {
  window.localStorage.setItem(config.localStorageKeys.checkoutProgress, 0)
}

function setCookiesHidden() {
  let now = new Date()
  window.localStorage.setItem(config.localStorageKeys.cookies, now.toDateString())
}

function getCookiesHidden() {
  let s = window.localStorage.getItem(config.localStorageKeys.cookies)
  if(s) {
    return true
  }
  else {
    return false
  }
}

/**
 * Retries a buddy adventure from storage
 */
function getBuddyAdventure() {
  let adventure = null
  let s = window.localStorage.getItem(config.localStorageKeys.buddy)
  if(s) {
    try {
      adventure = JSON.parse(s)
    }
    catch(error) {
      adventure = null
    }
  }
  return adventure
}

/**
 * Stores buddy adventure in local storage
 * @param {*} adventure 
 */
function setBuddyAdventure(adventure) {
  window.localStorage.setItem(config.localStorageKeys.buddy, JSON.stringify(adventure));
}

export default {
  getAdventure,
  setAdventure,
  setPurchases,
  getPurchases,
  getFavourites,
  setFavourites,
  setCheckoutProgress,
  getCheckoutProgress,
  resetCheckoutProgress,
  getCookiesHidden,
  setCookiesHidden,

  getBuddyAdventure,
  setBuddyAdventure
}